import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import type { GridProps } from '@chakra-ui/react'
import { Button, Flex } from '@chakra-ui/react'

export interface InsuranceQuoteGroupFooterProps extends GridProps {
  onAddNewVariant?: () => void
  enableAddVariant?: boolean
}

export const InsuranceQuoteGroupFooter = ({
  sx,
  onAddNewVariant,
  enableAddVariant,
  ...rest
}: InsuranceQuoteGroupFooterProps) => {

  const { isDisabled } = useInsuranceParams()

  return (
    <Flex
      sx={{
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      {...rest}
    >
      {enableAddVariant &&
        <Button colorScheme="primary" onClick={() => onAddNewVariant?.()} isDisabled={isDisabled}>
          Přidat další variantu pojištění
        </Button>
      }
    </Flex>
  )
}
